import { useIdentity } from ".";
import { useCallback, useEffect, useState } from "react";
import { getIdentityUtils } from "../utils";

interface useShopsTermPopupProps {
  acceptShopCharges: boolean;
  isShopsTermsAndConditionsAccepted: boolean;
  ready: boolean;
}

export default function useShopsTermPopup({
  acceptShopCharges,
  isShopsTermsAndConditionsAccepted,
  ready,
}: useShopsTermPopupProps) {
  const identity = useIdentity();
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (!ready || !acceptShopCharges || isShopsTermsAndConditionsAccepted)
      return;
    const { isTenant } = getIdentityUtils(identity);
    const isAdminUser =
      isTenant() && identity?.capabilities?.includes?.("ACCEPT-SHOP-TERMS");
    if (!isAdminUser) return;

    const key = `shops.fees_popup_${identity.company_id}`;
    const last = localStorage.getItem(key);
    const now = Date.now();
    if (last && now - parseInt(last, 10) < 48 * 60 * 60 * 1000) return;

    setShowPopup(true);
    localStorage.setItem(key, now.toString());
  }, [ready, acceptShopCharges, isShopsTermsAndConditionsAccepted, identity]);
  const dismiss = useCallback(() => setShowPopup(false), []);

  return { showPopup, dismiss };
}
